import { render, staticRenderFns } from "./com-message.vue?vue&type=template&id=8ccdc0c2&scoped=true&"
import script from "./com-message.vue?vue&type=script&lang=js&"
export * from "./com-message.vue?vue&type=script&lang=js&"
import style0 from "./com-message.vue?vue&type=style&index=0&id=8ccdc0c2&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccdc0c2",
  null
  
)

export default component.exports